import { IconProps as ChakraIconProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

import { IconTypes, iconRegistry } from './icon-registry'

export type IconProps = ChakraIconProps & { icon: IconTypes }

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ icon, ...props }, ref) => {
    const FoundIcon = iconRegistry[icon]

    if (!FoundIcon) {
      console.error(`Icon ${icon} not found in icon registry.`)
      return null
    }

    return <FoundIcon ref={ref} {...props} />
  },
)
